import React from 'react';

import FeaturedPostList from 'components/FeaturedPost';

const FeaturedPost = () => <FeaturedPostList />;

export default FeaturedPost;
